export const COLORS = {
  white: '#FFFFFF',
  primaryLight: '#EEF5FF',
  primarySemiLight: '#CFE0FF',
  primaryExtraLight: '#F5FAFE',
  primaryDark: '#387DFF',
  primaryExtraDark: '#0052E0',
  secondaryLight: '#C1C9E0',
  secondaryExtraDark: '#252E48',
  secondary: '#7683A8',
  secondarySemiDark: '#545F7E',
  secondaryDark: '#363F5A',
  secondarySemiLight: '#9AA6C8',
  borderColor: '#DDE3F0',
  accentRed: '#FF4C4C',
  warningColor: '#E79E00',
  secondaryUltraLight: '#EDEFF6',
  goldDark: '#F9A11A',
  lightGreen: '#90EE90',
  purple: '#4136C1'
}

export const BOX_SHADOW_COLOR = '#1b55d81f'
export const SUCCESS_GREEN_COLOR = '#3ABC9C'
